import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const isFullAdmin = (user) => !!user && (['role_super_admin', 'role_admin'].includes(user.role_id) || (!user.role_id && user.is_admin));

// Human label for a stored/previewed tax result; legacy quotes (no details) keep their old wording
export const taxLabel = (q) => {
  const d = q?.tax_details;
  if (!d) return q?.tax_reason ? `Tax (${q.tax_reason})` : 'Tax';
  if (d.status === 'pending_address') return 'Tax (to be confirmed)';
  if (d.status === 'calculated') return `Tax (${d.jurisdiction?.name || d.destination?.state || ''} ${d.rate}%)`;
  if (d.status === 'exempt') return 'Tax (exempt)';
  if (d.status === 'override') return `Tax (adjusted ${d.rate}%)`;
  return 'Tax (not collected)';
};

export const useTaxPreview = ({ subtotal, destination, customerEmail, quoteId, token, refreshKey }) => {
  const [result, setResult] = useState(null);
  const key = JSON.stringify([subtotal, destination, customerEmail, quoteId, refreshKey]);
  useEffect(() => {
    if (!token) return undefined;
    const t = setTimeout(async () => {
      try {
        const res = await axios.post(`${API}/api/tax/preview`, { subtotal: subtotal || 0, destination: destination || {}, customer_email: customerEmail, quote_id: quoteId },
          { headers: { Authorization: `Bearer ${token}` } });
        setResult(res.data);
      } catch { setResult(null); }
    }, 600);
    return () => clearTimeout(t);
  }, [key, token]); // eslint-disable-line react-hooks/exhaustive-deps
  return result;
};

export const TaxTotals = ({ subtotal, preview, formatPrice, testId = 'tax-totals' }) => (
  <>
    <div className="flex justify-between text-sm" data-testid={`${testId}-tax`}>
      <span className="text-neutral-500">{preview ? taxLabel(preview) : 'Tax (calculating…)'}</span>
      <span className="font-mono">{preview?.tax_details?.status === 'pending_address' ? 'TBC' : formatPrice(preview?.tax || 0)}</span>
    </div>
    {preview?.tax_reason && <p className="text-[11px] text-neutral-400 text-right" data-testid={`${testId}-reason`}>{preview.tax_reason}</p>}
    <div className="flex justify-between text-lg font-bold pt-2 border-t">
      <span>Total</span>
      <span className="font-mono" data-testid={`${testId}-total`}>{formatPrice((subtotal || 0) + (preview?.tax || 0))}</span>
    </div>
  </>
);
